import { LightningElement, api, track } from 'lwc';
import {publicPropertyToBool} from '../../../utils/basicUtils.js'
import {handleReadOnlySearch, suppressEscape, handleDropdownFlip, handleUnifiedClick} from '../../../utils/comboboxUtils.js';
import { getLabelsByLanguage } from '../../../utils/languageUtil';

export default class Dropdownplain extends LightningElement {
    @track isKeyIds = false;
    @track _preventBlur = false;
    @api isStickyValue = false;
    @api hasMeta  = false;

    _currentValue; 
    @api 
    set currentValue(val) {
        this._currentValue = val;
    }
    get currentValue() {
        return this._currentValue;
    }


    @api suppressFlip = false;
    @api alwaysFlip = false;

    @api 
    set placeHolder(val) {
        this._placeHolder = getLabelsByLanguage(val);
    }
    get placeHolder() {
        return this._placeHolder ?? getLabelsByLanguage('Select an Option');
    }
    @api 
    set label(val) {
        this._label = getLabelsByLanguage(val);
    }
    get label() {
        return this._label ?? '';
    }

    _inited = false;
    @api inputHeight;

    @api 
    set borderRadius(val) {
        this._borderRadius = val;
        if (val) {
            this._applyVarsDirect('--input-radius', val)
        }
    }
    get borderRadius() {
        return this._borderRadius;
    }

    @api 
    set fontSize(val) {
        this._fontSize = val;
        if (val) {
            this._applyVarsDirect('--input-font-size', val)
        }
    }
    get fontSize() {
        return this._fontSize;
    }

    //@track localOptions = [];
    originalValue = null;
    eventSending = false;

    @track isComboBoxOpen = false;
    @track highlightedOptionId = null;

    _readOnlyStrTimeStamp;
    _readOnlyStr = '';   // Allow user to type to try to find an option 
    _comboboxOptions;

    @api required=false;
    @track hasError = false;
    errorMsg;

    @api // Close on blur if is popover 
    set isPopover(val) {
        this._isPopover = val && (val===true || val==='true');
    }
    get isPopover() {
        return this._isPopover;
    }

    // Disable a field
    @api set isDisabled(val) {this._isDisabled = publicPropertyToBool(val);}
    get isDisabled() {return this._isDisabled || false;}
    

    @api // Set to true to prevent close event on Tab keydown
    set isTabbable(val) { this._isTabbable = publicPropertyToBool(val); }
    get isTabbable() { return this._isTabbable; }

    @api // Clear Selection once selection is made
    set isClearSelection(val) {
        this._isClearSelection = val && (val === "true" || val === true);
    }
    get isClearSelection() {
        return this._isClearSelection;
    }

    _options;
    @api // List of options for combobox
    set options(value) {
        if (value) {
            this.originalValue = this._currentValue;

            if (value.some(option => option.hasOwnProperty('keyId'))) {
                this.isKeyIds = true; // Flag that the options have key ids
            }
            this._options = value.map(option => {
                return {
                    ...option, 
                    label: getLabelsByLanguage(option.label),
                    isSelected: this._currentValue 
                        ? option.value === this._currentValue 
                        : false,
                }
            });
        }
    }
    get options() {
        return this._options;
    }

    
    // ================= Events Communcation ================ \\
    // Send event to parent when an option has been selected
    handleSelection(isNullSelection=false, key=null) {
        try {
            if (isNullSelection  && this._isPopover) {
                this.dispatchEvent(new CustomEvent('escape', { detail: key && key === 'Tab' ? 'Tab' : '' } ));
                return;
            }
            if (!this.eventSending) {
                this.eventSending = true;
                // Remove the error flag if an option was selected
                if (this.hasError) {
                    // Check that a selection was made from the options
                    if (this._options.some(opt => opt.value === this._currentValue)) {
                        this.hasError = false;
                    }
                }

                setTimeout(() => {
                    this.dispatchEvent(new CustomEvent('selection', { detail: {selection: this._currentValue} } ));
                    this.eventSending = false;
                    if (this.isClearSelection) { this._currentValue = ''; }
                }, 25);
            }
        } catch(error) {
            this.showToast('Error in handleSelection() of dropdownPlain.js: ', error);
        }
    }
    // Send this._currentValue to requester
    @api sendValues() {
        return this._currentValue;
    }
    @api getValue() {
        return this._currentValue;
    }
    // Clear selection and focus the combobox
    @api clearMenu() {
        setTimeout(() => {
            this._currentValue = null;
            this.originalValue = null;
        }, 250);
        //comboboxInput.focus();
    }
    @api focusMe() {
        const comboboxInput = this.template.querySelector('[data-id="popoverInput"]');
        comboboxInput.focus();
    }
    // Flag error with the combobox
    @api errorMe() {
        this.hasError = true;
    }
    // ===================================================== \\

    // Add slds-has-error is <this.hasError> is true
    get formElementClass() {
        return this.hasError 
            ? "slds-form-element slds-has-error"
            : "slds-form-element";
    }
    // Capitalize letters of the ticker
    get valueLabel() {
        return this._currentValue 
            ? this.localOptions.find(opt => String(opt.value) === String(this._currentValue))?.label ?? this._currentValue
            : null; 
    }

    // ===================== Callbacks ===================== \\
    // Initialize <-localOptions-> && store <-originalValue->
    renderedCallback() {
        const comboOpts = this.template.querySelectorAll('[data-id="comboboxOption"]');
        if (comboOpts) this._comboboxOptions = comboOpts;

        if (!this._inited) {
            this._applyVars();
            this._inited = true;
        }
        console.log('herre is current value in renderedCallback() of dropdownPlain.js: ', this._currentValue);
        console.log('here is options in renderedCallback() of dropdownPlain.js: ', JSON.stringify(this._options));
    }
    // ===================================================== \\

    // Clear error if value is present
    updateHasError() {
        if (this._currentValue  && this.hasError) {
            this.hasError = false;
        }
    }

    // Handle Combobox option Click events
    handleOptionClick(event) {
        try {
            const dataVal = event.currentTarget.dataset.value;
            const selectedOption = this.template.querySelector(
                `[data-id="comboboxOption"][data-value="${CSS.escape(dataVal)}"]`
            );
            this._currentValue = dataVal;
            this.updateHasError();
            this.handleSldsAriaCombobox(null, selectedOption, true);
            
            this.toggleCombobox();
        }catch(error) {
            console.error('handleOptionClick', 'SldsCombobox', error)
        }
    }

    get localOptions() {
        return this._options.map(opt => {
            return opt.value === this._currentValue
                ? {...opt, isSelected: true}
                : {...opt, isSelected: false}
        });
    }
    
    // Handle open/close triggering events for Combobox
    toggleCombobox(event=null, comboboxParam=null) {
        try {
            if (event) {
                suppressEscape(event);
            }
            const mutedKeys = ['Control', 'Alt', 'Meta', 'Shift'];
            if (event && event.key && mutedKeys.some(muted => event.key === muted)) {
                return;
            }
            // If combobox not open and Escape pressed --> Remove the combobox from the DOM (or slds-hide)
            if (event && event.key && event.key === 'Escape' && !this.isComboBoxOpen) {
                suppressEscape(event);
                this.handleSelection(true); // Send a null selection so parent knows to hide/remove combobox
                return;
            }

            // If is a Keyboard action handle Aria/slds
            if (event && event.key && event.key !== undefined) {
                if (this.isComboBoxOpen) {
                    // If combobox dropdown is open --> Bounce the keyDown events to the comboboxOptions keyDown handler
                    if (event.key !== undefined && event.key === 'Escape') {
                        suppressEscape(event);
                        event.stopPropagation();
                    }
                    event.preventDefault();
                    this.handleComboboxKeyDown(event);
                    return;

                } else if(!this.isComboBoxOpen && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
                    // Make sure page does not scroll down when user wants to open combobox
                    event.preventDefault();
                    let toFocusIndex = 0;
                    const comboboxOptions = this.template.querySelectorAll('[data-id="comboboxOption"]');
                    if (this._currentValue) {
                        this.handleSldsAriaCombobox(null, comboboxOptions[nextIndex], true);
                        
                        this._options = this._options.map( (opt, index) => {
                            if (opt.value === this._currentValue) toFocusIndex = index;
                            return {...opt, isSelected: opt.value === this._currentValue};
                        });
                    } else {

                    }
                    comboboxOptions[toFocusIndex].classList.add('slds-has-focus');
                }
            }

            // Handle Option clicks --> save selection & close combobox
            if ([event, comboboxParam].every(param => !param)) {
                const combobox = this.template.querySelector('[data-id="combobox"]');
                // When option is clicked it also triggers the dropdown toggler --> must set timeout to bounce it
                setTimeout(() => {
                    try {
                        this.handleSldsAriaCombobox(combobox, null, false);
                        requestAnimationFrame(() => {
                            handleDropdownFlip(this);
                        })
                    }catch(error) { console.error('toggleCombobox-timeout', 'SldsCombobox', error); }
                }, 20);

                return;
            }

            // Query the markup for combobox 
            const combobox = event ? this.template.querySelector('[data-id="combobox"]') : comboboxParam;
            if (!combobox) return; // Exit if no combobox is found

            // Open the Combobobox (forced)
            if ((!event && comboboxParam) || (!event.key || event.key === undefined)) {
                // Toggle the 'slds-is-open'
                this.handleSldsAriaCombobox(combobox);
                return;
            }

            // Open the Combobobox on click
            if (event && event.key && event.key !== undefined && ['Tab', 'Escape'].every(keyType => event.key !== keyType)) { 
                this.handleSldsAriaCombobox(combobox, null, true);
            }

        }catch(error) {
            console.error('Error in toggleCombobox() of dropdownPlain.js: ', error)
        }
    }
    
    // Control the combobox slds class states && the Aria attributes
    handleSldsAriaCombobox(combobox=null, comboboxOptions=null, isPositive=null, key=null) {
        try {
            // Handle Combobox Input element as parameter
            if (combobox) {

                if (isPositive === null) {
                    // Case 1: (is an actual toggle) --> 'isPositive' is neither true or false
                    const isOpen = combobox.classList.toggle('slds-is-open');
                    combobox.setAttribute('aria-expanded', isOpen ? 'true' : 'false'); 
                    this.isComboBoxOpen = isOpen ? true : false; 
                    if (isOpen) {
                        this.handleFocusOnOpen();
                        // Notify parent of open and focus the current selected option
                        requestAnimationFrame(() => handleDropdownFlip(this));
                        
                    }

                } else if(isPositive === false) {
                    // Case 2: Force the combobox dropdown to close
                    combobox.classList.remove('slds-is-open'); 
                    combobox.setAttribute('aria-expanded', 'false');
                    this.isComboBoxOpen = false;
                } else {
                    // Case 3: Force the combobox to open
                    combobox.classList.add('slds-is-open'); 
                    combobox.setAttribute('aria-expanded', 'true');
                    this._options.forEach(option => option.isSelected = this._currentValue === option.value); // action='findSelected'
                    this.handleFocusOnOpen();
                    this.isComboBoxOpen = true;
                    requestAnimationFrame(() => handleDropdownFlip(this));
                }
            }
            // Handle Combobox List option elements as parameter
            if (comboboxOptions) {
                // Handle single combobox option OR all combobox options
                if (Array.from(comboboxOptions).length > 1) {
                    // Case 1: Operate on all combobox options 
                    if (isPositive) {
                        // Case 1.a: Find the focused combobox && mark it as selected && update the current <-draftValue->
                        const selected = Array.from(comboboxOptions).find(option => option.classList.contains('slds-has-focus')); 
                        if (!selected) return;
                        if (!selected.classList) return;
                        selected.classList?.add('slds-is-selected');  // Mark the focused combox as "slds-is-selected"
                        selected.setAttribute('aria-checked', 'true'); // Mark the focused combox as "aria-checked=true"
                        selected.classList.add('slds-has-focus');
                        selected.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); // Ensure visibility
                        this._options.forEach(option => option.isSelected = option.value === selected.dataset.value); // action='UpdateDraftValue'
                        this._currentValue = selected.dataset.value;
                        this.updateHasError();

                    } else {
                        // Case 1.b: Mark all options as not 'slds-is-selected' and not 'aria-checked'
                        comboboxOptions.forEach(option => {option.classList.remove('slds-is-selected'); option.setAttribute('aria-checked', 'false') });
                    }
                    
                } else {
                    // Case 2: Operate on single combobox option
                    if (isPositive) {
                        // Case 2.a: set focus/aria-selected to false  on the single option

                        // Remove focus from all options
                        this._comboboxOptions?.forEach(combo => {combo.classList.remove('slds-has-focus'); combo.setAttribute('aria-selected', 'false');});
                        comboboxOptions.classList.add('slds-has-focus');
                        comboboxOptions.setAttribute('aria-selected', 'true');
                        comboboxOptions.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); // Ensure visibility
                    } else {
                        // Case 2.b: set focus/aria-selected to true  on the single option
                        comboboxOptions.classList.remove('slds-has-focus');
                        comboboxOptions.setAttribute('aria-selected', 'false');
                        comboboxOptions.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); // Ensure visibility
                    }

                }
            }

            // Pass event to parent component if selection was made
            if (!this.isComboBoxOpen) {
                key && key === 'Tab' 
                    ? this.handleSelection(false, 'Tab') 
                    : this.handleSelection();
            }
        }catch(error) {
            console.error('Error in handleSldsAriaCombobox() of dropdownPlain.js: ', error)
        }
    }
  
    // Handle combobox keyboard navigations
    handleComboboxKeyDown(event) {
        try {
            // Keys the comobobox should ignore
            const mutedKeys = ['Control', 'Alt', 'Meta', 'Shift'];
            if (mutedKeys.some(muted => event.key === muted)) { return; }

            // Keys that close the combobox (do not prevent default)
            const closeKeys = ['Escape', 'Tab'];

            // Get the combobox element
            const combobox = this.template.querySelector('[data-id="combobox"]');
            if (!combobox) return;

            // Close on "Escape" and open combobox on any other keyDown
            if (event && event.key && event.key !== undefined) {
                if (closeKeys.some(close => close === event.key)) { 
                    suppressEscape(event);
                    // Close combobox on "Escape"
                    this.handleSldsAriaCombobox(combobox, null, false, event.key);    
                    event.stopPropagation();
                } else {
                    // Open the combobox
                    if (!combobox.classList.contains('slds-is-open')) {
                        this.toggleCombobox(null, combobox);
                        requestAnimationFrame(() => handleDropdownFlip(this));
                    }
                }
            } 

            const comboboxOptions = this.template.querySelectorAll('[data-id="comboboxOption"]');     
            if (!comboboxOptions) return;

            // Find the currently focused item
            const focused = Array.from(comboboxOptions).findIndex(option => option.classList.contains('slds-has-focus'));

            if (event && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) { 
                event.preventDefault(); 
                // Remove focus from the current item, if any
                if (focused !== -1) {
                    this.handleSldsAriaCombobox(null, comboboxOptions[focused], false);
                }

                // Calculate the next item index
                let nextIndex = 0; 
                if (event && event.key === 'ArrowDown') {
                    nextIndex = focused + 1 < comboboxOptions.length ? focused + 1 : 0; 
                } else {
                    nextIndex = focused - 1 > -1 ? focused - 1 : comboboxOptions.length - 1;
                }

                // Add focus to the next item
                this.handleSldsAriaCombobox(null, comboboxOptions[nextIndex], true);
                comboboxOptions[nextIndex].classList.add('slds-has-focus');

            } else if (event && event.key === 'Enter') {
                // Mark and option as slds-is-selected
                this.handleSldsAriaCombobox(null, comboboxOptions, false);  // Set all options to slds-is-selected and aria-checked  to false
                this.handleSldsAriaCombobox(null, comboboxOptions, true);  // Set the option with slds-has-focus to slds-is-selected/aria-checked
                this.handleSldsAriaCombobox(combobox, null, false);       // Close the combobox
            }
        }catch(error) {
            console.error('Error in handleComboboxKeyDown() of dropdownPlain.js: ', error)
        }
    }

    // Add slds-has-focus to the options when hovered
    handleHover(event) {
        try {
            if (this._comboboxOptions && this._comboboxOptions !== undefined && this._comboboxOptions.length > 0) {
                this._comboboxOptions.forEach(opt => {
                    if (event.currentTarget.dataset.value === opt.dataset.value) {
                        opt.classList.add('slds-has-focus');
                    } else {
                        if (opt.classList.contains('slds-has-focus')) {
                            opt.classList.remove('slds-has-focus');
                        }
                    }
                })
            }
        } catch(error) {
            console.error('handleHover', 'SldsCombobox', error);
        }
    }
    // Remove slds-has-focus to the options when un-hovered
    handleUnhover(event) {
        try {
            event?.currentTarget?.classList?.remove('slds-has-focus');
        }catch(error) {
            console.error('handleUnhover', 'SldsCombobox', error);
        }
        
    }

  
    // Remove any highlight from the input box when focused
    handleFocus(event) {
        const input = event.target;
        // Move the cursor to the end without selecting the text
        const length = input.value.length;
        input.setSelectionRange(length, length);
    }


    // Don't allow focus to leave the input element when a list-option is clicked
    deflectFocus(event) {
        event.preventDefault();
    }

    handleInputKeyDown(event) {
        suppressEscape(event);
        if (event.key === 'Tab' && !this.isComboBoxOpen && this._isPopover && this._isTabbable) {
            this._preventBlur = true;
            event.stopPropagation();
            return;
        }    

        const ignoreKeys = ['Enter', 'Escape', 'Shift', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
        if (event?.key && ignoreKeys.some(ignore => ignore === event.key)) {
            this._readOnlyStr = '';
            return;
        }
        if (!this._comboboxOptions) {
            // Query template for the combobox options
            const combos = this.template.querySelectorAll('[data-id="comboboxOption]');
            if (combos) this._comboboxOptions = combos;
        }


        // how many ms have passed
        const diffMs = Date.now() - this._readOnlyStrTimeStamp; 
        if (diffMs > 2000) {
            this._readOnlyStr = '';
        }
        
        const {nextStr, match, index} = handleReadOnlySearch(event, String(this._readOnlyStr ?? ''), this._options);
        if (typeof nextStr === 'string') {
            this._readOnlyStr = nextStr;
            this._readOnlyStrTimeStamp = Date.now(); 
            
            if (match) {
                const matchedEle = Array.from(this._comboboxOptions)?.find(ele => 
                    String(ele.dataset.value) === String(match.value)
                );

                if (matchedEle) {
                    // Remove slds-has-focus from all the options
                    this._comboboxOptions.forEach(combo => {
                        if (combo === matchedEle) {
                            matchedEle.classList.add('slds-has-focus');
                            matchedEle.setAttribute('aria-selected', 'true');
                            matchedEle.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); // Ensure visibility
                        } else {
                            combo.classList.remove('slds-has-focus'); 
                            combo.setAttribute('aria-selected', 'false');
                        }
                    });
                }
            }
        }
    }

    // Close the combobox when input blurred
    handleBlur(event) {
        try {
            if (this._isPopover && !this._isTabbable) {
                if (!this._preventBlur) {
                    this.dispatchEvent(new CustomEvent('escape', { detail: '' } ));
                } else {
                    this._preventBlur = false;
                }
            }
            event.preventDefault();
            // Get the combobox element (dropdownTrigger)
            const combobox = this.template.querySelector('[data-id="combobox"]');

            if (!combobox) return;

            // Close combobox
            setTimeout(() => { combobox.classList.remove('slds-is-open'); }, 30)
            //this.handleSldsAriaCombobox(combobox, null, false);  
            if (this.required && !this._currentValue) {
                this.hasError = true;
            }
            
        }catch(error) {
            console.error('handleBlur', 'SldsCombobox', error);
        }
    }

    get dropdownLengthCl() {
        const optionsLength = this.localOptions?.length;

        let dropdownLengthCl = 'slds-dropdown_length-5';

        if (optionsLength) {
            if (optionsLength >= 20) {
                dropdownLengthCl = 'slds-dropdown_length-10'
            } else if (optionsLength >= 12) {
                dropdownLengthCl = 'slds-dropdown_length-7'
            }
        }

        return `slds-dropdown ${dropdownLengthCl} slds-dropdown_fluid`
    }

    handleFocusOnOpen(optEles) {
        const cOptions = optEles ?? this.template.querySelectorAll('[role="option"]');
        if (this._currentValue) {
            cOptions.forEach(o => {
                if (o.dataset.value === this._currentValue) {
                    o.classList.add('slds-has-focus');
                    o.setAttribute('aria-selected', 'true');
                    o.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); // Ensure visibility
                } else {
                    if (o.classList.contains('slds-has-focus')) {
                        o.removeAttribute('aria-select');
                        o.classList.remove('slds-has-focus');
                    }
                }
            })
        } else {
            cOptions.forEach((o, index) => {
                if (index === 0) {
                    o.classList.add('slds-has-focus');
                    o.setAttribute('aria-selected', 'true');
                    o.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); // Ensure visibility
                } else {
                    if (o.classList.contains('slds-has-focus')) {
                        o.removeAttribute('aria-select');
                        o.classList.remove('slds-has-focus');
                    }
                }
            })
        }
    }

    _unifiedCl = '';
    @api 
    set unified(val) {
        this._unified = val;
        if (val) {
            this._applyVarsDirect('--input-border', 'none');
            this._unifiedCl = `${this._unifiedCl} gw-unified-form-element`.trim();
        }
    }
    get unified() {
        return this._unified;
    }

    _applyVars() {
        if (this.inputHeight) this.style.setProperty('--input-height',  `${this.inputHeight}`);
    }

    // Apply Styles to the host 👉 Can pass 1.Array of Arrays   2.Array of Object   3.Strings
    _applyVarsDirect(cssVar, varStyle=null, eleAttr=null) {

        if (eleAttr) {
            const ele = this.template.querySelector(cssVar);
            if (ele) {
                ele.style[eleAttr] = varStyle;
            }
            return;
        }

        // Check that CSS var starts with '--' and has a non-null stlye 
        const isValid = (cssVarP, varStyleP) => {
            return typeof cssVarP === 'string' && 
                typeof varStyleP === 'string' &&
                cssVarP?.startsWith('--') && 
                varStyleP;
        }


        if (Array.isArray(cssVar)) {
            // Handle Array of vars
            cssVar.forEach(hostVar => {
                if (Array.isArray(hostVar) && isValid(hostVar[0], hostVar[1])) {
                    // Handle Array structure  (CSS var at index 0)
                    this.style.setProperty(hostVar[0], hostVar[1]);
                } else if (typeof hostVar === 'object' && isValid(hostVar.cssVar, hostVar.varStyle)) {
                    // Handle Object structure (cssVar & varStyle keys)
                    this.style.setProperty(hostVar.cssVar, hostVar.varStyle)
                }
            });
        } else if (isValid(cssVar, varStyle)) {
            // Handle string arguments
            this.style.setProperty(cssVar,  varStyle);
        }
    }


    handleUnifiedClick(event) {
        handleUnifiedClick(this, event);
    }
}